import { HttpInterceptorFn } from '@angular/common/http';

const LOGIN_PATH = '/authentication/login';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Don't add token to login requests
  if (req.url.includes(LOGIN_PATH)) {
    return next(req);
  }

  const token = localStorage.getItem('SierraToken');
  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Site-Id': '698d23639742c79b2f8cb1f1',
      },
    });
    return next(authReq);
  }

  return next(req);
};
